import { useContext, useState } from 'react'

import { FormContext } from 'Components/Hooks/ContextForm'
import SetState from 'Components/Hooks/SetState'
import useCustomSnackbar from 'Components/UI/Atoms/SnackBar'
import CancelConfirmButtons from 'Components/UI/Molecules/CancelConfirmButtons'
import DialogComponent from 'Components/UI/Molecules/Modals/DialogComponent'
import { TabPanel } from 'Helpers'
import { interfaces } from 'service/interfaces'

import ContentAppBarTabs from '../Tabs/Main'

import AnexaConControl from './AnexaConControl'
import AnexaSinControl from './AnexaSinControl'
import styles from './styles'

const SideTabs = (props) => {
  const { value, vehiculoTipo } = props
  const { formEdit } = useContext(FormContext)
  const [loading, setLoading] = useState(false)
  const [revisionConfirm, setRevisionConfirm] = useState(false)
  const revisionObleas = formEdit.vehicle.revision_obleas

  const createDismissableSnackbar = useCustomSnackbar()

  const { state, setClose, setOpen } = SetState()

  async function handleOpen() {
    setLoading(false)
    setOpen()
  }

  const revision = async () => {
    setLoading(true)
    await interfaces.vehicleInterface
      .switchRevisionOblea(formEdit.vehicle.id)
      .then((res) => {
        createDismissableSnackbar(res.data, {
          variant: 'success',
        })
        setRevisionConfirm(true)
      })
      .catch((error) => {
        createDismissableSnackbar(error.response.data.data, {
          variant: 'error',
        })
      })
    setLoading(false)
    setClose()
  }

  const classes = styles()

  return (
    <div className={classes.style}>
      <TabPanel value={props.value} index={0}>
        <ContentAppBarTabs
          value={value}
          habilitar={revisionObleas}
          handleOpenRev={handleOpen}
          revisionConfirm={revisionConfirm}
          loading={loading}
          vehiculoTipo={vehiculoTipo}
        />
      </TabPanel>

      <TabPanel value={props.value} index={1}>
        <AnexaSinControl
          value={value}
          habilitar={revisionObleas}
          revisionConfirm={revisionConfirm}
        />
      </TabPanel>

      <TabPanel value={props.value} index={2}>
        <AnexaConControl
          value={value}
          habilitar={revisionObleas}
          revisionConfirm={revisionConfirm}
        />
      </TabPanel>

      {state.suspense && (
        <DialogComponent
          open={state.open}
          title="¿Desea confirmar que verificó el listado de obleas?"
          handleclose={setClose}
          widthLarge="400px"
          maxHeight
          disableBackdropClick
          disableEscapeKeyDown
          actions={
            <CancelConfirmButtons onClickCancel={() => setClose()} onClickSubmit={revision} />
          }
        />
      )}
    </div>
  )
}

export default SideTabs
